import { Study, StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';

export const isStudyOfType = (studyType: StudyType) => (study: Study) =>
  study.Type === studyType;
